'use client';

import styles from './styles.module.css';

export default function Button({
  label = 'Contact',
  children,
  onClick,
  className = '',
  ...props
}) {
  const text = typeof children === 'string' ? children : label;
  const chars = Array.from(text);

  const safe = (ch) => (ch === ' ' ? '\u00A0' : ch);

  return (
      <button
        type="button"
        onClick={onClick}
        className={[styles.btn, className].filter(Boolean).join(' ')}
        {...props}
      >
        <span className={styles.words}>
          <span className={styles.word}>
            {chars.map((ch, i) => (
              <span key={`a-${i}`} className={styles.char} style={{ '--i': i }}>
                {safe(ch)}
              </span>
            ))}
          </span>

          <span className={styles.word}>
            {chars.map((ch, i) => (
              <span key={`b-${i}`} className={styles.charAlt} style={{ '--i': i }}>
                {safe(ch)}
              </span>
            ))}
          </span>
        </span>

        <span className={styles.arrow} aria-hidden="true">
          ↗
        </span>
      </button>
  );
}
